import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/GlobalStyle.css'
import CustomFooter from '../login/CustomFooter'
import DistrictStatsV2 from './../admin/DistrictStatsV2'
import { getIDFromURL, getQueryStringParam, flattenDoc } from '../Util'
import { Layout, Row, Col, Select, Spin, Tabs, Icon } from 'antd'
import ColType from '../Types'
import { db } from '../firebase/Firebase'
import PersonAvatar from '../customcomponents/PersonAvatar'
import SchoolReport from '../admin/SchoolReport'
import SchoolUploads from '../admin/SchoolUploads'
import SchoolPlanningReport from '../admin/SchoolPlanningReport'
import SchoolPracticeReport from '../admin/SchoolPracticeReport'
import SchoolProgressReport from '../admin/SchoolProgressReport'
import TeacherSummary from '../admin/TeacherSummary'
import SAMScoring from '../admin/SAMScoring'
import ProfessionalLearningReport from '../admin/ProfessionalLearningReport'
import ConsultationReport from '../admin/ConsultationReport'
import SchoolTeamworkReport from '../admin/SchoolTeamworkReport'
const { Content } = Layout
const TabPane = Tabs.TabPane

class InstructionalFacilitatorSchoolView extends Component {
    state = {
        newPopoverVisible: false,
        accountPopoverVisible: false,
        adminId: '',
        prevSelectedId: null,
        selectedId: null,
        teacherId: '',
        studentId: '',
        teacher: null,
        student: null,
        teachers: [],
        teacherDict: {},
        students: [],
        studentDict: {},
        IEPGoals: [],
        IEPDict: {},
        calendarEvents: null,
        calendarDict: null,
        events: null,
        dataLoaded: false,
        dataRetrieved: false,
        studentReportData: {},
        teacherTab: 'schedule',
        loadingData: false,
        readOnly: true,
    }

    // Do fetch here
    componentDidMount() {
        document.title = 'School Reports - Dot It'

        let instructionalFacilitatorId = getIDFromURL(window.location)
        let prevSelectedId = this.state.selectedId
        let selectedId = getQueryStringParam('s')
        let dataLoaded = this.state.dataLoaded

        // home page
        if (!selectedId && this.props.instructionalFacilitatorBaseProps.schools && this.props.instructionalFacilitatorBaseProps.schools.length > 0) {
            selectedId = this.props.instructionalFacilitatorBaseProps.schools[0].id
        }

        if (prevSelectedId !== selectedId) {
            dataLoaded = false
        }

        this.setState({
            instructionalFacilitatorId: instructionalFacilitatorId,
            selectedId: selectedId,
            prevSelectedId: selectedId,
            dataLoaded: dataLoaded,
        }, () => {
            this.getTeachers()
        })
    }

    componentWillReceiveProps(props, newProps) {
        let instructionalFacilitatorId = getIDFromURL(window.location)
        let prevSelectedId = this.state.selectedId
        let selectedId = getQueryStringParam('s')
        let dataLoaded = this.state.dataLoaded

        // home page
        if (!selectedId && this.props.instructionalFacilitatorBaseProps.schools && this.props.instructionalFacilitatorBaseProps.schools.length > 0) {
            selectedId = this.props.instructionalFacilitatorBaseProps.schools[0].id
        }

        if (prevSelectedId !== selectedId) {
            dataLoaded = false
        }

        this.setState({
            instructionalFacilitatorId: instructionalFacilitatorId,
            selectedId: selectedId,
            prevSelectedId: selectedId,
            dataLoaded: dataLoaded,
        }, () => {
            this.getTeachers()
        })
    }

    getTeachers = () => {
        if (this.state.dataLoaded) {
            return
        }

        if (this.state.selectedId && this.props.instructionalFacilitatorBaseProps.instructionalFacilitator) {
            this.setState({
                dataLoaded: true,
                dataRetrieved: false,
            })

            db.collection(ColType.teacher)
                .where('districtId', '==', this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId)
                .where('schoolIds', 'array-contains', this.state.selectedId)
                .get()
                .then((querySnapshot) => {
                    let teachers = []
                    let teacherDict = {}

                    querySnapshot.forEach((doc) => {
                        let teacher = flattenDoc(doc)
                        if (!(teacher.hasOwnProperty('isVisible') && !teacher.isVisible)) {
                            teachers.push(teacher)
                            teacherDict[teacher.id] = teacher
                        }
                    })

                    if (teachers.length === 0) {
                        db.collection(ColType.teacher)
                            .where('districtId', '==', this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId)
                            .where('schoolId', '==', this.state.selectedId)
                            .get()
                            .then((querySnapshot) => {
                                let teachers = []
                                let teacherDict = {}

                                querySnapshot.forEach((doc) => {
                                    let teacher = flattenDoc(doc)
                                    if (!(teacher.hasOwnProperty('isVisible') && !teacher.isVisible)) {
                                        teachers.push(teacher)
                                        teacherDict[teacher.id] = teacher
                                    }
                                })

                                teachers.sort((a, b) => {
                                    if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
                                        return 1
                                    } else {
                                        return -1
                                    }
                                })

                                this.setState({
                                    teachers: teachers,
                                    teacherDict: teacherDict,
                                    dataRetrieved: true,
                                })
                            })
                    } else {
                        teachers.sort((a, b) => {
                            if (a.lastName.charAt(0) > b.lastName.charAt(0)) {
                                return 1
                            } else {
                                return -1
                            }
                        })

                        this.setState({
                            teachers: teachers,
                            teacherDict: teacherDict,
                            dataRetrieved: true,
                        })
                    }
                })
        }
    }

    newVisibleChange = (visible) => {
        this.setState({ newPopoverVisible: visible })
    }

    accountVisibleChange = (visible) => {
        this.setState({ accountPopoverVisible: visible })
    }

    onChange = (value) => {
        console.log(`selected ${value}`)
    }

    onSelect = (value, option) => {
        console.log('on select', value, option)
        console.log('/teacher/student/' +
            this.props.person.id + '?student=' +
            option.key)

        this.props.history.push(
            {
                pathname: '/admin/school-summary/' +
                    this.props.person.id + '?district=' +
                    this.props.person.districtId + '&school=' +
                    option.key
            }
        )
    }

    onSchoolOrDistrictSelect = (schoolOrDistrict) => {
        if (this.props.instructionalFacilitatorBaseProps.district &&
            this.props.instructionalFacilitatorBaseProps.district.id === schoolOrDistrict) {
            this.props.history.push(
                {
                    pathname: '/admin/admin-home/' +
                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id
                }
            )
        }
        else {
            this.props.history.push(
                {
                    pathname: '/admin/admin-home/' +
                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + schoolOrDistrict
                }
            )
        }
    }

    teacherClick = (teacher) => {
        this.setState({
            teacher: teacher,
            teacherId: teacher.id
        })

        this.getStudents(teacher)

        window.scroll(0, 0)
    }

    studentClick = (student) => {
        this.setState({
            student: student,
            studentId: student.id,
            studentReportData: {
                teacherId: this.state.teacher.id,
                studentId: student.id,
                teacher: this.state.teacher,
                student: student,
                teachers: this.state.teachers,
                students: this.state.students,
                studentDict: this.state.studentDict,
                // goals for this student
                IEPGoals: this.state.IEPGoals.filter((e) => e.studentId === student.id),
                IEPDict: this.state.IEPDict,
            }
        })

        window.scroll(0, 0)
    }

    onSchoolOrDistrictSelect = (schoolOrDistrict) => {
        this.setState({
            selectedOptionId: schoolOrDistrict
        })

        if (this.props.instructionalFacilitatorBaseProps.district &&
            this.props.instructionalFacilitatorBaseProps.district.id === schoolOrDistrict) {
            this.props.history.push(
                {
                    pathname: '/admin/admin-home/' +
                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id
                }
            )
        }
        else {
            this.props.history.push(
                {
                    pathname: '/admin/admin-home/' +
                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + schoolOrDistrict
                }
            )
        }
    }

    getSchoolTypeIcon = (school) => {
        let schoolIcon = '/school-icons/1.png'
        if (school.hasOwnProperty('schoolType')) {
            if (school.schoolType === 'k8School') {
                schoolIcon = '/school-icons/2.png'
            } else if (school.schoolType === 'middleSchool') {
                schoolIcon = '/school-icons/3.png'
            } else if (school.schoolType === 'highSchool') {
                schoolIcon = '/school-icons/4.png'
            }
        }

        return schoolIcon
    }

    render() {
        let selectedId = this.props.schoolId
        let selectedStats = null
        let selectedDisplayName = ''
        if (selectedId && this.props.instructionalFacilitatorBaseProps.district) {
            if (this.props.instructionalFacilitatorBaseProps.schoolsDict &&
                this.props.instructionalFacilitatorBaseProps.schoolsDict.hasOwnProperty(selectedId)) {
                selectedDisplayName = this.props.instructionalFacilitatorBaseProps.schoolsDict[selectedId].schoolName
            }
            if (this.props.instructionalFacilitatorBaseProps.allStatOptionsDict.hasOwnProperty(selectedId)) {
                selectedStats = this.props.instructionalFacilitatorBaseProps.allStatOptionsDict[selectedId]
            }
        }
        return (
            <div>
                <div>
                    <Layout className="content relative layout-header-mt">
                        <Layout >
                            <Content>
                                <div>
                                    {this.state.instructionalFacilitatorId &&
                                        this.props.instructionalFacilitatorBaseProps.instructionalFacilitator &&
                                        this.props.instructionalFacilitatorBaseProps.district &&
                                        this.props.instructionalFacilitatorBaseProps.schoolsDict &&
                                        this.props.instructionalFacilitatorBaseProps.schools &&
                                        this.props.instructionalFacilitatorBaseProps.user &&
                                        this.props.schoolId
                                        ?
                                        <div>
                                            <div className="sub-menu-width-vlg m-lr-auto mt-3">
                                                <Row gutter={32}>
                                                    <Col span={18}>
                                                        <div>
                                                            {/* Breadcrumb: District > School */}
                                                            <div className="w-100 flex flex-v-center mb-2" style={{ fontSize: 16 }}>
                                                                <Link to={'/instructional-facilitator/instructional-facilitator-home/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id}
                                                                    style={{ fontWeight: 700, color: '#2d6a9f' }}>
                                                                    {this.props.instructionalFacilitatorBaseProps.district.district}
                                                                </Link>
                                                                <Icon type="right" className="ml-1 mr-1" style={{ fontSize: 13, color: '#94a3b8' }} />
                                                                <span style={{ fontWeight: 700, color: '#1e293b' }}>{selectedDisplayName}</span>
                                                            </div>
                                                            {/* Gradient hero banner with the school name */}
                                                            <div className='br-20 overflow-hidden mb-3 mt-2'>
                                                                <div className='br-20 p-3'
                                                                    style={{ minHeight: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                                                    <div className='h-100'>
                                                                        <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                                                            <div className='w-100'>
                                                                                <div className='font-40 font-bold font-fff'>{selectedDisplayName}</div>
                                                                                <div className='font-20 font-fff mt-1'>Teachers and school reports</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Friendly "what to do" banner */}
                                                            <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                                                <Icon type='team' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                                                <div>
                                                                    <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Choose a teacher or open a report</div>
                                                                    <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Use the tabs below to see this school's teachers or to open its reports. Click any teacher in the list to view their details. You can also search for a teacher by name. Use the panel on the right to switch schools.</div>
                                                                </div>
                                                            </div>
                                                            <Tabs className='tabs-less-margin-right' size={'large'}
                                                                defaultActiveKey="1" animated={false}>
                                                                <TabPane tab="Teachers" key="1">
                                                                    {this.state.teachers ?
                                                                        <div className='pl-2 pr-2 pt-4'>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="Search for a teacher"
                                                                                className='w-100 mb-2'
                                                                                optionFilterProp="children"
                                                                                onSelect={(teacherId) => {
                                                                                    if (this.props.instructionalFacilitatorBaseProps.instructionalFacilitator && teacherId && this.state.teacherDict.hasOwnProperty(teacherId)) {
                                                                                        this.props.history.push({
                                                                                            pathname: '/instructional-facilitator/teacher/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + this.state.selectedId + '&t=' + teacherId
                                                                                        })
                                                                                    }
                                                                                }}
                                                                                size="large"
                                                                                filterOption={(input, option) => {
                                                                                    let person = option.props.children.props.person
                                                                                    let fullName = person.firstName + ' ' + person.lastName
                                                                                    return fullName.toLowerCase().includes(input.toLowerCase())
                                                                                }}
                                                                            >
                                                                                {this.state.teachers.map((teacher, idx) => {
                                                                                    return <Select.Option value={teacher.id} key={'search-' + teacher.id}>
                                                                                        <PersonAvatar
                                                                                            person={teacher}
                                                                                            avatarColor={'#d3adf7'}
                                                                                            avatarTextColor={'#000'}
                                                                                            containerClassName="font-16"
                                                                                            avatarClassName="font-16 font-bold mr-2"
                                                                                            personClassName="font-black font-16"
                                                                                        />
                                                                                    </Select.Option>
                                                                                })}
                                                                            </Select>
                                                                        </div>
                                                                        : ''}
                                                                    {!this.state.dataRetrieved ?
                                                                        <div className='text-center mt-2 pl-2 pr-2'>
                                                                            <Spin size='large' />
                                                                        </div>
                                                                        : ''}
                                                                    {this.state.dataRetrieved && this.state.teachers && this.state.teachers.length === 0 ?
                                                                        <div className='pl-2 pr-2'>
                                                                            <div style={{ background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '18px 20px', fontSize: 16, color: '#475569' }}>
                                                                                No teachers yet.
                                                                            </div>
                                                                        </div>
                                                                        : ''}
                                                                    {this.state.dataRetrieved && this.state.teachers &&
                                                                        this.state.teachers.map((teacher, idx) => {
                                                                            return <div className='pl-2 pr-2' key={'teacher-row-' + teacher.id}>
                                                                                <Link to={'/instructional-facilitator/teacher/' + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + '?s=' + this.state.selectedId + '&t=' + teacher.id}
                                                                                    id={'right-menu-' + teacher.id}>
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '16px 20px', marginBottom: 12, boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px' }}>
                                                                                        <PersonAvatar
                                                                                            person={teacher}
                                                                                            size={'large'}
                                                                                            avatarColor={'#d3adf7'}
                                                                                            avatarTextColor={'#000'}
                                                                                            containerClassName="font-20"
                                                                                            avatarClassName="font-20 font-bold mr-1"
                                                                                            personClassName="font-black font-20 ellipsis"
                                                                                            personStyle={{ maxWidth: '219px' }}
                                                                                        />
                                                                                        <TeacherSummary teacher={teacher} />
                                                                                        <Icon type='right' style={{ marginLeft: 'auto', fontSize: 20, color: '#94a3b8' }} />
                                                                                    </div>
                                                                                </Link>
                                                                            </div>
                                                                        })}
                                                                </TabPane>
                                                                <TabPane tab="Our School Improvement Reports" key="professional-learning-reports">
                                                                    <div className='mt-3 pl-2 pr-2'>
                                                                        <ProfessionalLearningReport
                                                                            districtId={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId}
                                                                            schoolId={this.props.schoolId}
                                                                            personId={this.props.instructionalFacilitatorBaseProps.user.id}
                                                                        />
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tab="Coaching Reports" key="school-teamwork-reports">
                                                                    <div className='mt-3 pl-2 pr-2'>
                                                                        <SchoolTeamworkReport
                                                                            districtId={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId}
                                                                            schoolId={this.props.schoolId}
                                                                            personId={this.props.instructionalFacilitatorBaseProps.user.id}
                                                                        />
                                                                    </div>
                                                                </TabPane>

                                                                <TabPane tab="Consultation Reports" key="consultation-reports">
                                                                    <div className='mt-3 pl-2 pr-2'>
                                                                        <ConsultationReport
                                                                            districtId={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId}
                                                                            schoolId={this.props.schoolId}
                                                                            personId={this.props.instructionalFacilitatorBaseProps.user.id}
                                                                        />
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tab="Uploads" key="school-uploads">
                                                                    <div className='mt-3 pl-2 pr-2'>
                                                                        <SchoolUploads
                                                                            districtId={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.districtId}
                                                                            schoolId={this.props.schoolId}
                                                                            person={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator}
                                                                            accessLevel={ColType.instructionalFacilitator}
                                                                        />
                                                                    </div>
                                                                </TabPane>
                                                            </Tabs>
                                                        </div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <h1 className='font-24 font-bold mb-1'>Schools</h1>
                                                        {this.props.instructionalFacilitatorBaseProps.schools ?
                                                            <Select
                                                                showSearch
                                                                placeholder="Search for a school"
                                                                className='w-100 mb-2'
                                                                optionFilterProp="children"
                                                                onSelect={(schoolId) => {
                                                                    if (this.props.instructionalFacilitatorBaseProps.instructionalFacilitator && schoolId) {
                                                                        let idx = 0
                                                                        if (this.props.instructionalFacilitatorBaseProps.schools) {
                                                                            idx = this.props.instructionalFacilitatorBaseProps.schools.findIndex((school) => {
                                                                                return school.id === schoolId
                                                                            })
                                                                        }
                                                                        let url = '/instructional-facilitator/instructional-facilitator-home/'
                                                                        let qs = ''
                                                                        if (idx > 0) {
                                                                            url = '/instructional-facilitator/school/'
                                                                            qs = '?s=' + schoolId
                                                                        }
                                                                        let fullURL = url + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + qs
                                                                        this.props.history.push({
                                                                            pathname: fullURL
                                                                        })
                                                                    }
                                                                }}
                                                                size="large"
                                                                filterOption={(input, option) => {
                                                                    if (option.props.children.length < 2) {
                                                                        return false
                                                                    }
                                                                    return option.props.children[1].toLowerCase().includes(input.toLowerCase())
                                                                }}
                                                            >
                                                                {this.props.instructionalFacilitatorBaseProps.schools &&
                                                                    this.props.instructionalFacilitatorBaseProps.schools.map((school, idx) => {
                                                                        return <Select.Option value={school.id} key={'search-' + school.id}>
                                                                            <img src={this.getSchoolTypeIcon(school)} alt='school-icon' width={32} className='mr-1' />
                                                                            {school.schoolName}
                                                                        </Select.Option>
                                                                    })}
                                                            </Select>
                                                            : ''}
                                                        {this.props.instructionalFacilitatorBaseProps.schools && this.props.instructionalFacilitatorBaseProps.schools.length === 0 ?
                                                            <div style={{ background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '18px 20px', fontSize: 16, color: '#475569' }}>
                                                                No schools yet.
                                                            </div>
                                                            : ''}
                                                        {this.props.instructionalFacilitatorBaseProps.schools &&
                                                            this.props.instructionalFacilitatorBaseProps.schools.map((school, idx) => {
                                                                let url = '/instructional-facilitator/instructional-facilitator-home/'
                                                                let qs = ''
                                                                if (idx > 0) {
                                                                    url = '/instructional-facilitator/school/'
                                                                    qs = '?s=' + school.id
                                                                }
                                                                let isSelected = school.id === this.props.schoolId
                                                                return <Link to={url + this.props.instructionalFacilitatorBaseProps.instructionalFacilitator.id + qs}
                                                                    id={'right-menu-' + school.id}
                                                                    key={'right-menu-key-' + school.id}>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 8,
                                                                        background: '#fff',
                                                                        border: isSelected ? '2px solid #2d6a9f' : '1px solid #e8eef5',
                                                                        borderRadius: 16,
                                                                        padding: '12px 16px',
                                                                        marginBottom: 12,
                                                                        boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px',
                                                                        fontSize: 20,
                                                                        fontWeight: 900,
                                                                        color: '#1e293b'
                                                                    }}>
                                                                        <img src={this.getSchoolTypeIcon(school)} alt='school-icon' width={50} className='mr-1' />
                                                                        {school.schoolName}
                                                                    </div>
                                                                </Link>
                                                            })}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
                <CustomFooter />
            </div>
        )
    }
}

export default InstructionalFacilitatorSchoolView